import { Component } from "react";
import ErrorView from "../Pages/User/components/ErrorView";
import {
  NotFoundException,
  ForbiddenException,
  UnauthorizedException,
  ServerException,
  AppException,
} from "../exceptions/AppExceptions";

const ERROR_CONFIG = {
  NotFoundException: {
    heading: "Page Not Found",
    message: "The page you're looking for doesn't exist or has been moved.",
  },
  ForbiddenException: {
    heading: "Access Forbidden",
    message: "You don't have permission to view this page.",
  },
  UnauthorizedException: {
    heading: "Unauthorized",
    message: "You must be logged in to access this page.",
  },
  ServerException: {
    heading: "Server Error",
    message: "Something went wrong on our end. Please try again later.",
  },
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    const { error } = this.state;

    if (!error) return this.props.children;

    if (error instanceof NotFoundException) {
      return <ErrorView statusCode={404} heading={ERROR_CONFIG.NotFoundException.heading} message={error.message || ERROR_CONFIG.NotFoundException.message} />;
    }
    if (error instanceof ForbiddenException) {
      return <ErrorView statusCode={403} heading={ERROR_CONFIG.ForbiddenException.heading} message={error.message || ERROR_CONFIG.ForbiddenException.message} />;
    }
    if (error instanceof UnauthorizedException) {
      return <ErrorView statusCode={401} heading={ERROR_CONFIG.UnauthorizedException.heading} message={error.message || ERROR_CONFIG.UnauthorizedException.message} />;
    }
    if (error instanceof ServerException) {
      return <ErrorView statusCode={500} heading={ERROR_CONFIG.ServerException.heading} message={error.message || ERROR_CONFIG.ServerException.message} />;
    }
    if (error instanceof AppException) {
      return <ErrorView statusCode={error.statusCode} heading={`Error ${error.statusCode}`} message={error.message} />;
    }

    return <ErrorView statusCode={500} heading="Unexpected Error" message={error.message || "An unexpected error occurred."} />;
  }
}

export default ErrorBoundary;
